import { render, staticRenderFns } from "./RegisterFormComponent.vue?vue&type=template&id=fc4eafc6&scoped=true"
import script from "./RegisterFormComponent.vue?vue&type=script&lang=js"
export * from "./RegisterFormComponent.vue?vue&type=script&lang=js"
import style0 from "./RegisterFormComponent.vue?vue&type=style&index=0&id=fc4eafc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc4eafc6",
  null
  
)

export default component.exports